module.exports = "/_next/static/images/0e9840d28440ff1cdae6408b161b9561-mgm-10-million-desktop.jpg.webp";